import React, { Component } from "react"
import { Card, CardBody, Col, Media, Row } from "reactstrap"

import subdomains from "../constants/subdomains.json"

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const last = parts[parts.length - 1]
const is_localhost = last === "localhost"
const subdomain = parts[0] // 'swordsofblood', 'localhost', 'app'
// const subdomain = "swordsofblood"
// NOTE: for testing dynamic text rendering, change the subdomain value above

class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dashboardWelcomeTextHeader: subdomains[subdomain]?.dashboardWelcomeTextHeader, // "Welcome to the ..."
            dashboardWelcomeTextParagraph1: subdomains[subdomain]?.dashboardWelcomeTextParagraph1,
            dashboardWelcomeTextParagraph2: subdomains[subdomain]?.dashboardWelcomeTextParagraph2
        }
    }

    render() {
        const { dashboardWelcomeTextHeader, dashboardWelcomeTextParagraph1, dashboardWelcomeTextParagraph2 } = this.state
        return (
            <React.Fragment>
                <div className="content dashboard-page">
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <h4 className="mt-0 font-size-16">{dashboardWelcomeTextHeader}</h4>
                                    <p>{dashboardWelcomeTextParagraph1}</p>
                                    <p>{dashboardWelcomeTextParagraph2}</p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default Dashboard
